var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "absolute-fill d-flex justify-center",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [!_vm.playbackIsLoaded ? _c('div', {
    staticClass: "absolute-fill placeholder",
    staticStyle: {
      "z-index": "1"
    }
  }) : _vm._e(), _c('video', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.localSrc || _vm.video.src,
      expression: "localSrc || video.src"
    }],
    ref: "playback",
    staticClass: "playback",
    staticStyle: {
      "z-index": "2"
    },
    style: {
      transform: _vm.transform
    },
    attrs: {
      "height": "100%",
      "playsinline": "",
      "src": _vm.localSrc || _vm.video.src + (_vm.isBlob ? '' : '.mp4')
    },
    on: {
      "loadeddata": _vm.onLoadedData
    }
  }, 'video', !_vm.video.src || _vm.localSrc || _vm.isBlob ? {} : {
    poster: _vm.video.src + '_poster_0'
  }, false)), !_vm.localSrc && !_vm.video.src && _vm.isMediaRecorderSupported ? _c('video', {
    ref: "preview",
    staticClass: "playback",
    staticStyle: {
      "z-index": "2"
    },
    style: {
      transform: _vm.transform
    },
    attrs: {
      "height": "100%",
      "autoplay": "",
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }